<div class="fieldset title-area ">
  <legend>WorkBuddy</legend>
</div>

<div class="fieldset content-area">
  <div class="description description-title">Thank you for using WorkBuddy.</div>
  <div class="description">Your account is waiting for confirmation. You need to accept the invitation via email before continue.</div>
</div>